import { APIv3FormResource } from "core-app/modules/apiv3/forms/apiv3-form-resource";

export class APIv3UsersForm extends APIv3FormResource {
}

